import { API_URL } from "../service.config";
import info from "../../utils/info";

export default {
  createContact(contact: any) {
    return API_URL.post(`/contact`, contact);
  },

  deleteContact(contactID: string) {
    return API_URL.delete(`/contact/single/${contactID}`, {
      headers: {
        Authorization: `Bearer ${info.getToken()}`,
      },
    });
  },
  getContacts(pagination: any) {
    return API_URL.get(`/contact`, {
      headers: {
        Authorization: `Bearer ${info.getToken()}`,
      },
      params: {
        site: "admin",
        start: pagination.start,
        quantity: pagination.quantity || 10,
        ...(pagination.type && { type: pagination.type }),
      },
    });
  },
  exportContacts(type?: "bilboard" | "contact-us") {
    return API_URL.get(`/contact/export`, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${info.getToken()}`,
      },
      params: {
        site: "admin",
        ...(type && { type }),
      },
    });
  },
};
